import React, { useEffect, useRef, useState } from 'react'
import { formatDistanceStrict } from 'date-fns'
import { nl } from 'date-fns/locale'

export interface InputProps {
    value?: string
    min?: string
    max?: string
    name: string
    onChange: (studyLoad: string) => void
}

type studyLoadMapType = {
    [key: string]: string
}

export const studyLoadMap: studyLoadMapType = {
    '0': '3600',
    '3': '7200',
    '6': '10800',
    '9': '14400',
    '12': '18000',
    '15': '21600',
    '18': '25200',
    '21': '86400',
    '22': '172800',
    '23': '259200',
    '24': '345600',
    '25': '432000',
    '26': '518400',
    '27': '604800',
    '28': '691200',
    '29': '777600',
    '30': '864000',
    '31': '950400',
    '32': '1036800',
    '33': '1123200',
    '34': '1209600',
    '35': '1296000',
    '36': '1382400',
    '37': '1468800',
    '38': '1555200',
    '39': '1641600',
    '40': '1728000',
    '41': '1814400',
    '42': '1900800',
    '43': '1987200',
    '44': '2073600',
    '45': '2160000',
    '46': '2246400',
    '47': '2332800',
    '48': '2419200',
    '49': '2505600',
    '50': '2629744',
    '52': '5259488',
    '54': '7889232',
    '56': '10518976',
    '58': '13148720',
    '60': '15778464',
    '62': '18408208',
    '64': '21037952',
    '66': '23667696',
    '68': '26297440',
    '70': '28927184',
    '72': '31536000',
    '75': '63072000',
    '78': '94608000',
    '81': '126144000',
    '84': '157680000',
}

const Slider: React.FC<InputProps> = React.forwardRef(({ name, onChange, value, min, max }, ref) => {
    const isInitialMount = useRef(true)
    const [studyLoad, setStudyLoad] = useState<string>(value ? value : '0')

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false
        } else {
            const delayDebounceFn = setTimeout(() => {
                if (studyLoad) {
                    // write your logic here
                    onChange(studyLoad)
                }
            }, 800)
            return () => clearTimeout(delayDebounceFn)
        }
    }, [studyLoad])

    const getKeyByValue = (value: string | undefined) => {
        if (typeof value !== 'undefined') {
            return Object.keys(studyLoadMap).find((key) => studyLoadMap[key] === value)
        }
    }

    return (
        <div className="relative w-full pt-4 lea">
            <input
                className="w-full h-1 mb-3 bg-mariner-500 rounded-lg appearance-none cursor-pointer range-sm dark:bg-mariner-500"
                type={'range'}
                min="0"
                max="84"
                name={name}
                step="3"
                onChange={(e) => {
                    const value = parseInt(e.target.value)
                    let step
                    if (value > 20 && value < 50) {
                        step = '1'
                    } else if (value >= 50 && value < 72) {
                        step = '2'
                    } else {
                        step = '3'
                    }

                    const studyLoadValue = studyLoadMap[e.target.value] || '157680000'
                    setStudyLoad(studyLoadValue)
                    e.target.setAttribute('step', step)
                }}
                defaultValue={getKeyByValue(value)}
            />

            <span className="text-sm">{formatDistanceStrict(0, parseInt(studyLoad) * 1000, { locale: nl })}</span>
        </div>
    )
})

export default Slider
